module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.21d6dd0.eot";